import React, { PureComponent } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Button from '../../Part_Sample/Button';
import History_Log_Cell from './History_Log_Cell';
import { isEmpty, getLocale } from '../../Common/Common';

import prev from '../../../Images/Icons/carat-l-black.svg';
import next from '../../../Images/Icons/carat-r-black.svg';

export default class History extends PureComponent {
	constructor(props) {
		super(props);

		window.app.hideLoading();
		this.lastClickTime = false;

		this.isTouchPanel = false;
		if(this.props.receiver.active_controller.ip_addr == 'localhost' && this.props.receiver.active_controller.comm_module.is_local) {
			if(!this.props.receiver.is_mobile && window.location.port != '8080') this.isTouchPanel = true;
		}

		let search_date = new Date();
		if (this.props.param.search_date != null) search_date = this.props.param.search_date;

		this.filters = {};
		if (this.props.param.filters != null) this.filters = this.props.param.filters;

		this.history_data = JSON.parse(JSON.stringify(this.props.param.history_data));
		// Check if data is too big, split it into parts
		this.max_record = 30;
		if(this.isTouchPanel) this.max_record = 6;
		
		this.filtered_data = this.getFilteredData();
		this.paged_data = this.populateData();

		this.state = {
			display_data: this.paged_data,
			search_date: search_date,
		}

		// Create Ref and populate records while scrolling
		this.history_ref = React.createRef();
	}

	shouldComponentUpdate(nextProps, nextState) {
		return this.state.display_data != nextState.display_data;
	}

	preventMultipleTaps = () => {
		if(this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handlePrevious = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler(this.props.param.from, this.props.param);
	}

	handleChangeFilter = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('History_Change_Filter', {
			from: this.props.param.from,
			history_data: this.history_data,
			search_date: this.state.search_date,
			filters: this.filters,
		});
	}

	getFilteredData = () => {
		let display_data = [];
		
		//Should use all data(this.history_data), instead of partial data(this.paged_data), for filter to work properly
		//let paged_data = this.paged_data;
		let history_data = this.history_data;
		
		/*
		 * Filters index
		 * 0 = timestamp
		 * 1 = type
		 * 2 = command
		 * 3 = point id/function id
		 * 4 = data
		 * 5 = operator (i.e. who)
		 */
		if (isEmpty(this.filters)) {
			display_data = JSON.parse(JSON.stringify(history_data));
		} else {
			for (let i in history_data) {
				if ((this.filters['type'] == null || history_data[i][1] == this.filters['type'])
					&& (this.filters['command'] == null || history_data[i][2] == this.filters['command'])
					&& (this.filters['target'] == null || history_data[i][3] == this.filters['target'])
					&& (this.filters['data'] == null || history_data[i][4] == this.filters['data'])
					&& (this.filters['operator'] == null || history_data[i][5] == this.filters['operator'])
				) {
					display_data.push(history_data[i]);
				}
			}

		}

		return display_data;
	}

	handlePrev = () => {
		if (!this.preventMultipleTaps()) return;

		window.app.showLoading();
		this.history_data = [];
		let new_search_date = this.state.search_date;
		new_search_date.setDate(new_search_date.getDate() - 1)

		let search_date_param = {
			year: new_search_date.getFullYear(),
			month: new_search_date.getMonth() + 1,
			day: new_search_date.getDate(),
		}

		this.setState({ search_date: new_search_date });
		this.props.receiver.getHistory(search_date_param);
	}

	handleNext = () => {
		if (!this.preventMultipleTaps()) return;

		this.history_data = [];
		let today = new Date();
		today.setHours(0, 0, 0);
		if (this.state.search_date >= today) {
			return;
		}
		window.app.showLoading();
		let new_search_date = this.state.search_date;
		new_search_date.setDate(new_search_date.getDate() + 1)

		let search_date_param = {
			year: new_search_date.getFullYear(),
			month: new_search_date.getMonth() + 1,
			day: new_search_date.getDate(),
		}

		this.setState({ search_date: new_search_date });
		this.props.receiver.getHistory(search_date_param);
	}

	populateData = () => {
		let history_data = JSON.parse(JSON.stringify(this.filtered_data));

		if(!this.isTouchPanel) {
			if (history_data.length > this.max_record) {
				this.max_record += 30;		//increment by 30
				if (this.max_record > history_data.length) this.max_record = history_data.length
			}
		}

		window.app.hideLoading();

		return history_data.slice(0, this.max_record);
	}

	handleOnScroll = () => {
		if(this.isTouchPanel) return; //return if it is touch screen, touch screen use historyScroll function to move

		if (!this.is_populating && (this.history_ref.current.scrollTop >= this.history_ref.current.scrollHeight -  this.props.height //1250 //2500
			&& this.filtered_data.length > this.max_record)) {
			window.app.showLoading();
			this.is_populating = true;
			// this.paged_data = this.populateData();
			this.setState({ display_data: this.populateData() }, () => {
				this.is_populating = false;
				window.app.hideLoading();
			});
		}
	}

	historyScroll = (direction) => {
		let history_data = JSON.parse(JSON.stringify(this.filtered_data));

		switch(direction) {
			case 'top':
				if(this.max_record <= 6) return; // Stop processing if already at top of list

				if(history_data.length < 6) {
					this.max_record = history_data.length;
				} else {
					this.max_record = 6;
				}
				break;
			case 'up':
				if(this.max_record <= 6) return; // Stop processing if already at top of list

				this.max_record -= 6;
				
				if(history_data.length < 6) {
					this.max_record = history_data.length;
				} else {
					if(this.max_record < 6) this.max_record = 6;
				}
				break;
			case 'down':
				if(this.max_record == history_data.length) return; // Stop processing if already at bottom of list

				this.max_record += 6;

				if(this.max_record > history_data.length) this.max_record = history_data.length;
				break;
			case 'bottom':
				if(this.max_record == history_data.length) return; // Stop processing if already at bottom of list

				this.max_record = history_data.length;
				break;
			default:
				console.log('Unexpected historyScroll parameter.');
		}

		let firstIndex = this.max_record - 6;
		if(firstIndex < 0) firstIndex = 0; 

		this.setState({ display_data: history_data.slice(firstIndex, this.max_record) }, () => {
			this.history_ref.current.scrollTop = 0;
		});
	}

	rcvHistory = (history_data) => {
		this.lastClickTime = false;

		if (history_data == null || history_data.length < 1) {
			window.app.hideLoading();
			window.app.showToast(this.props.receiver.getString('no_data'), 3000);
			this.setState({ display_data: [] });
		} else {
			this.history_data = JSON.parse(JSON.stringify(history_data));

			this.filtered_data = this.getFilteredData();
			this.paged_data = this.populateData();
			this.setState({ display_data: this.paged_data });
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let history_content_style = {
			overflow: 'auto',
			height: this.props.height - 70,
		}

		let button_style = { 
			color: this.props.colours.button_font, 
			width: '100%', 
			padding: '22px 15px',
			borderRadius: 0,
			margin: 0, 
			marginRight: 'auto', 
			marginLeft: 'auto', 
			textAlign: 'center' 
		}

		let locale = getLocale(this.props.receiver.lang);
		let df_options = { year: 'numeric', month: 'long', day: 'numeric' };
		let display_date = this.state.search_date.toLocaleString(locale, df_options);

		let is_show_next = true;
		let today = new Date();
		today.setHours(0, 0, 0);
		if (this.state.search_date >= today) {
			is_show_next = false;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('history')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'edit'}
						handleRightButton={this.handleChangeFilter}
					/>
					<div style={history_content_style}>
						<div>
							<div style={{ display: 'inline-block', verticalAlign: 'top', height: 35, width: 35, cursor: 'pointer' }} onClick={this.handlePrev}>
								<img src={prev} />
							</div>

							<div style={{ display: 'inline-block', verticalAlign: 'top', height: 35, width: this.props.width - 70, cursor: 'pointer' }} >
								<span className='title'>{display_date}</span>
							</div>

							<div style={{ display: 'inline-block', verticalAlign: 'top', height: 35, width: 35, cursor: 'pointer' }} onClick={this.handleNext}>
								<img src={next} style={{ display: is_show_next ? 'block' : 'none' }} />
							</div>
						</div>
						<div style={{ display: this.isTouchPanel ? 'flex' : 'block', flexDirection: 'row'}} className='noScrollBar'>
							<div ref={this.history_ref} style={{ height: this.props.height - 140, width: this.isTouchPanel ? '90%' : '100%', overflow: 'auto', paddingTop: 20 }} onScroll={this.handleOnScroll}>
							{this.state.display_data.map((history_row_item) => {
								return (
									<History_Log_Cell
										history_row_item={history_row_item}
										width={ this.isTouchPanel ? this.props.width * 0.90 : this.props.width }
										height={this.props.height}
										receiver={this.props.receiver}
									/>
								);
							})}
						</div>
							<div id='touch_menu_buttons' style={{ width: '3%', display: this.isTouchPanel ? 'flex' : 'none', flexDirection: 'column' }}>
								<Button id="history_top" style={{...button_style, opacity: this.max_record <= 6 ? 0.5 : 1}} bgColor={this.props.colours.button_light_gray} onClick={() => this.historyScroll('top')}>&#9650;<br/>&#9650;</Button>
								<Button id="history_up" style={{...button_style, marginBottom: '20px', opacity: this.max_record <= 6 ? 0.5 : 1}} bgColor={this.props.colours.button_light_gray} onClick={() => this.historyScroll('up')}>&#9650;</Button>
								<Button id="history_down" style={{...button_style, opacity: this.max_record == this.filtered_data.length ? 0.5 : 1}} bgColor={this.props.colours.button_light_gray} onClick={() => this.historyScroll('down')}>&#9660;</Button>
								<Button id="history_bottom" style={{...button_style, opacity: this.max_record == this.filtered_data.length ? 0.5 : 1}} bgColor={this.props.colours.button_light_gray} onClick={() => this.historyScroll('bottom')}>&#9660;<br/> &#9660;</Button>
							</div>
						</div>	
					</div>
				</div>
			</div>
		)
	}
}